import React from 'react';
import { Warning, X } from '@phosphor-icons/react';
import { Button } from '../../components/ui/button';

/**
 * Yellow banner shown above the Patients/Employees lists when there are
 * "Needs completion" stubs auto-created from timesheet scans.
 *
 * Clicking the link applies the "Needs completion" status filter so the
 * biller can quickly cycle through them.
 */
const NeedsCompletionBanner = ({ count, onClickComplete, recordLabel = 'patient' }) => {
  if (!count) return null;
  const plural = count === 1 ? recordLabel : `${recordLabel}s`;
  return (
    <div
      className="bg-amber-50 border border-amber-300 rounded-lg p-3 flex items-start gap-3"
      data-testid={`needs-completion-banner-${recordLabel}`}
    >
      <Warning size={20} weight="fill" className="text-amber-600 shrink-0 mt-0.5" />
      <div className="flex-1 min-w-0">
        <p className="text-sm font-semibold text-amber-900">
          {count} {plural} need{count === 1 ? 's' : ''} completion
        </p>
        <p className="text-xs text-amber-700 mt-0.5">
          Auto-created from timesheet scans. Fill in DOB, Medicaid ID, and payer before
          submitting claims.
        </p>
      </div>
      <Button
        variant="outline"
        size="sm"
        className="bg-white border-amber-400 text-amber-900 hover:bg-amber-100"
        onClick={onClickComplete}
        data-testid={`needs-completion-cta-${recordLabel}`}
      >
        Complete now
      </Button>
      <button
        type="button"
        onClick={() =>
          (document.querySelector(
            `[data-testid="needs-completion-banner-${recordLabel}"]`
          ) || {}).style &&
          (document.querySelector(
            `[data-testid="needs-completion-banner-${recordLabel}"]`
          ).style.display = 'none')
        }
        className="text-amber-500 hover:text-amber-700 p-1"
        aria-label="Dismiss"
      >
        <X size={14} />
      </button>
    </div>
  );
};

export default NeedsCompletionBanner;
